<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-button type="primary" @click="bCreateSendEmployee=true"> 添加</el-button>
        <el-button type="success" @click="fnSendAllStock()"> 一键发放</el-button>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="sendLists" border stripe>
        <el-table-column label="姓名" prop="name" align="center" />
        <el-table-column label="职位" prop="title" align="center" />
        <el-table-column label="金额" align="center">
          <template slot-scope="{row}">
            <p>{{ row.amount/100 }}</p>
          </template>
        </el-table-column>
        <el-table-column label="股数" align="center">
          <template slot-scope="{row}">
            {{ row.share_num/100 }}
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="{row}">
            {{ findArray(stockTypes,"id",row.exercise_type) >= 0 ? stockTypes[findArray(stockTypes,"id",row.exercise_type)].name : stockTypes[0].name }}
          </template>
        </el-table-column>
        <el-table-column label="行权周期" prop="exercise_title" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnDeleteExercise(row.warehouse_id)">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetExerciseList" />
    </div> -->
    <el-dialog v-if="bCreateSendEmployee" class="abow_dialog" top="50" title="添加员工" :visible.sync="bCreateSendEmployee" width="70%">
      <add-send-empolyee @successCBK="fnGetWaitSendStockLists()" />
    </el-dialog>
  </div>

</template>

<script>
import Tool from '@/assets/js/tool.js'

import AddSendEmpolyee from './AddSendEmpolyee'
import commondata from '@/utils/commondata'

export default {
  name: 'WaitSendStockLists',
  components: {
    AddSendEmpolyee
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      sendLists: [],
      stockTypes: commondata.STOCK_TYPE,
      bCreateSendEmployee: false
    }
  },
  created() {
    this.fnGetWaitSendStockLists()
  },
  methods: {
    fnGetWaitSendStockLists() {
      this.bCreateSendEmployee = false
      this.$http.getWarehomeList().then(res => {
        this.tableKey++
        this.sendLists = res.data
      })
    },
    fnDeleteExercise(warehouseId) {
      this.$confirm('是否取消发放股金？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.revocationWarehouseCheckIn({ warehouseId }).then(res => {
          this.fnGetWaitSendStockLists()
        })
      }).catch(() => {

      })
    },
    findArray(list, key, value) {
      return Tool.findIndexInArryByKeyVal(list, key, value)
    },
    fnSendAllStock() {
      this.$confirm('是否确认操作一键发放股金？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.giveCapital().then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '发放成功'
            })
            this.fnGetWaitSendStockLists()
          }
        })
      }).catch(() => {

      })
    }

  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
.abow_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
    .el-dialog {
        margin: 0 auto !important;
        height: 90%;
        overflow: hidden;
        .el-dialog__body {
            position: absolute;
            left: 0;
            top: 60px;
            bottom: 0;
            right: 0;
            padding: 30px;
            z-index: 1;
            overflow: hidden;
            overflow-y: auto;
        }
    }
}
</style>
